/**
 * This is the percentage of the list that will be traversed before triggering the next page.
 */
export const PERCENTAGE_OF_LIST_TO_TRAVERSE_BEFORE_TRIGGERING_NEXT_PAGE = 0.61;
